import { useCallback, useState } from "react";
import { useHotkey } from "../../Hooks/useHotkey/useHotkey";
import { ArrowDown, ArrowUp } from "../../Utils/Keys";
/**
 * A hook that returns the current focused row id and a method to set the focused row id.
 * @returns [focusedRowId, onRowFocus]
 */
export function useArrowRowFocus(ref) {
    const [focusedRowId, setFocusedRowId] = useState();
    const onArrowDown = useCallback((e) => {
        // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const targetElement = e.target;
        // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const next = targetElement?.nextElementSibling;
        if (next) {
            next.focus();
        }
    }, []);
    const onArrowUp = useCallback((e) => {
        // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const targetElement = e.target;
        // This was written prior to adding @typescript-eslint/consistent-type-assertions, please refactor when possible.
        // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
        const previous = targetElement?.previousElementSibling;
        if (previous) {
            previous.focus();
        }
    }, []);
    useHotkey(useCallback((e) => {
        onArrowDown(e);
    }, [onArrowDown]), ref, ArrowDown);
    useHotkey(useCallback((e) => {
        onArrowUp(e);
    }, [onArrowUp]), ref, ArrowUp);
    const onRowFocus = useCallback((row) => {
        if (row) {
            setFocusedRowId(row.id);
        }
        else {
            setFocusedRowId(undefined);
        }
    }, [setFocusedRowId]);
    return [focusedRowId, onRowFocus];
}
